import React, { Component } from "react";
import "../Ventas/ventas.css";
import "./nacionalidades.css";
import { toast } from "react-toastify";
import { editarNacionalidad, getListaNacionalidad, guardarNacionalidad } from "../../service/api";
import NacionalidadModal from "../../componentes/modal/nacionalidad/NacionalidadModal";
import SpinnerModal from "../../componentes/spiner/SpinnerModal";
import Navbar from "../../componentes/navbar/navbar";



export default class NacionalidadesPage extends Component {
  state = {
    loading: false,
    nacionalidades: [],
    filterText: "",
    showModal: false,
    modalMode: "create", // create | edit
    selected: null,
    selectedRowId: null,
    sortKey: "nacionalidad",
    sortDir: "asc",
  };

  componentDidMount() {
    const datos = localStorage.getItem("datosm");
    if (!datos || datos === "") {
      window.location.href = "/";
      return;
    }

    this.fetchNacionalidades();
  }

  normalize = (item) => {
    return {
      idnacionalidad: item?.idnacionalidad ?? null,
      nacionalidad: item?.nacionalidad ?? "",
      codigo: item?.codigo ?? "",
      _key: String(item?.idnacionalidad ?? Math.random()),
    };
  };

  compareValues = (a, b) => {
    if (a == null) a = "";
    if (b == null) b = "";

    const na = Number(a);
    const nb = Number(b);

    const bothNumeric =
      !Number.isNaN(na) &&
      !Number.isNaN(nb) &&
      String(a).trim() !== "" &&
      String(b).trim() !== "";

    if (bothNumeric) return na - nb;

    return String(a).localeCompare(String(b), "es", {
      numeric: true,
      sensitivity: "base",
    });
  };

  getSortValue = (item, key) => {
    switch (key) {
      case "idnacionalidad":
        return item.idnacionalidad;
      case "nacionalidad":
        return item.nacionalidad;
      case "codigo":
        return item.codigo;
      default:
        return "";
    }
  };

  onSort = (key) => {
    this.setState((prev) => {
      const same = prev.sortKey === key;
      const nextDir = same && prev.sortDir === "asc" ? "desc" : "asc";
      return { sortKey: key, sortDir: nextDir };
    });
  };

  getSortedItems = (items) => {
    const { sortKey, sortDir } = this.state;

    return [...(items || [])].sort((aa, bb) => {
      const a = this.getSortValue(aa, sortKey);
      const b = this.getSortValue(bb, sortKey);
      const cmp = this.compareValues(a, b);
      return sortDir === "asc" ? cmp : -cmp;
    });
  };

  fetchNacionalidades = async () => {
    this.setState({ loading: true });

    try {
      const resp = await getListaNacionalidad();

      if (resp && resp.code === 0) {
        const raw = Array.isArray(resp.data) ? resp.data : [];
        const nacionalidades = raw.map(this.normalize);

        this.setState({
          nacionalidades,
          loading: false,
        });
        return;
      }

      toast.info((resp && resp.message) || "No se pudieron obtener nacionalidades.");
      this.setState({ loading: false });
    } catch (e) {
      toast.info("Error al obtener nacionalidades.");
      this.setState({
        nacionalidades: [],
        loading: false,
      });
    }
  };

  onSaveNacionalidad = async (payload) => {
    this.setState({ showModal: false, loading: true });

    try {
      let r = null;

      if (this.state.modalMode === "edit") {
        const id = this.state?.selected?.idnacionalidad;
        r = await editarNacionalidad(id, payload);
      } else {
        r = await guardarNacionalidad(payload);
      }

      if (r && r.code === 0) {
        toast.success(r.message || "Guardado correctamente.");
        this.setState({
          showModal: false,
          selected: null,
          modalMode: "create",
          selectedRowId: null,
        });
        this.fetchNacionalidades();
        return;
      }

      toast.info(`${r?.code ?? ""} ${r?.message ? "- " + r.message : ""}`.trim());
      this.setState({ loading: false });
    } catch (e) {
      toast.info("Error al guardar nacionalidad.");
      this.setState({ loading: false });
    }
  };

  openCreate = () => {
    this.setState({
      showModal: true,
      modalMode: "create",
      selected: null,
      selectedRowId: null,
    });
  };

  openEdit = (row) => {
    this.setState({
      showModal: true,
      modalMode: "edit",
      selected: row,
      selectedRowId: row?.idnacionalidad ?? null,
    });
  };

  closeModal = () => {
    this.setState({
      showModal: false,
      selected: null,
      modalMode: "create",
      selectedRowId: null,
    });
  };

  onSelectRow = (row) => {
    const id = row?.idnacionalidad ?? null;
    this.setState((prev) => ({
      selectedRowId: prev.selectedRowId === id ? null : id,
    }));
  };

  getFilteredItems = () => {
    const q = String(this.state.filterText || "").trim().toLowerCase();
    const items = this.state.nacionalidades || [];

    if (!q) return items;

    return items.filter((n) => {
      const s = [n.idnacionalidad, n.nacionalidad, n.codigo]
        .join(" ")
        .toLowerCase();

      return s.includes(q);
    });
  };

  render() {
    const {
      loading,
      filterText,
      showModal,
      modalMode,
      selected,
      selectedRowId,
    } = this.state;

    const filtered = this.getFilteredItems();
    const items = this.getSortedItems(filtered);

    return (
      <div className="v-page">
        <Navbar />

        {loading ? <SpinnerModal tipo="full" show={loading} /> : null}

        <NacionalidadModal
          show={showModal}
          mode={modalMode}
          nacionalidad={selected}
          loading={loading}
          onClose={this.closeModal}
          onSave={this.onSaveNacionalidad}
        />

        <div className="na-shell">
          <div className="v-top">
            <h1 className="v-title">Nacionalidades</h1>

            <div className="na-actions">
              <div className="so-search">
                <span className="so-ico" aria-hidden="true">🔎</span>

                <input
                  type="text"
                  value={filterText}
                  onChange={(e) =>
                    this.setState({
                      filterText: e.target.value,
                      selectedRowId: null,
                    })
                  }
                  placeholder="Buscar nacionalidad, código..."
                  disabled={loading}
                />

                {String(filterText || "").length > 0 && (
                  <button
                    type="button"
                    className="so-clear"
                    onClick={() =>
                      this.setState({
                        filterText: "",
                        selectedRowId: null,
                      })
                    }
                    disabled={loading}
                    aria-label="Limpiar"
                    title="Limpiar"
                  >
                    ✕
                  </button>
                )}
              </div>

              <button className="v-btn" onClick={this.openCreate} disabled={loading}>
                AGREGAR NACIONALIDAD
              </button>
            </div>
          </div>

          <div className="vard">
            <div className="v-card">
              <div className={`v-tableWrap ${showModal ? "lock-scroll" : ""}`}>
                <table className="v-table">
                  <thead>
                    <tr>
            
                      <th
                        className="v-thSort"
                        onClick={() => this.onSort("nacionalidad")}
                      >
                        Nacionalidad
                      </th>
                      <th
                        className="v-thSort"
                        onClick={() => this.onSort("codigo")}
                      >
                        Código
                      </th>
                      <th>Acciones</th>
                    </tr>
                  </thead>

                  <tbody>
                    {items.length === 0 ? (
                      <tr>
                        <td colSpan="4" className="v-empty">
                          No hay registros disponibles
                        </td>
                      </tr>
                    ) : (
                      items.map((n, idx) => {
                        const isActive = selectedRowId === n.idnacionalidad;

                        const rowClass = [
                          idx % 2 === 0 ? "even" : "odd",
                          isActive ? "row-active" : "",
                        ]
                          .join(" ")
                          .trim();

                        return (
                          <tr
                            key={`${n._key}-${idx}`}
                            className={rowClass}
                            onClick={() => this.onSelectRow(n)}
                            style={{ cursor: "pointer" }}
                          >
                            <td>{n.nacionalidad}</td>
                            <td className="v-mono">{n.codigo}</td>
                            <td onClick={(e) => e.stopPropagation()}>
                              <button
                                className="na-linkBtn"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.openEdit(n);
                                }}
                                disabled={loading}
                                title="Editar"
                              >
                                Editar
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}